import {
    buildAssignmentChangeSet,
    getAssignmentPayload,
    hasAssignableQuestions,
    mapAssignedPortalIds,
    mapAssignedPortals,
    mapAssignedProfileIds,
    mapAssignedProfileNames,
} from './create_form.utils';

export default {
    sync_assigned_state(form_id, selected_profile_ids, selected_portal_ids) {
        this.sync_assigned_profiles(form_id, selected_profile_ids);
        this.sync_assigned_portals(form_id, selected_portal_ids);
    },
    handle_assignment_success(selected_profile_ids, selected_portal_ids) {
        this.sync_assigned_state(this.form_id, selected_profile_ids, selected_portal_ids);
        this.reset_assignment_selections();
        this.close_assign_modal();
    },
    get_form_by_id(form_id) {
        return this.forms.find((form) => form.id === form_id) || null;
    },
    sync_assigned_profiles(form_id, selected_profile_ids) {
        const form = this.get_form_by_id(form_id);
        if (!form) return;

        form.assigned_profile_types = mapAssignedProfileNames(this.profile_types, selected_profile_ids);
    },
    sync_assigned_portals(form_id, selected_portal_ids) {
        const form = this.get_form_by_id(form_id);
        if (!form) return;

        form.assigned_portals = mapAssignedPortals(this.portals, selected_portal_ids);
    },
    has_assignment_selection() {
        return this.selected_profiles.length > 0 || this.selected_portals.length > 0;
    },
    has_assignment_changes(changes) {
        return changes.hasUnassignments || changes.hasAssignments;
    },
    notify_no_assignment_selection() {
        this.show_toast("error", "No Selection Made", "Please select at least one profile type or portal.");
    },
    notify_no_assignment_changes() {
        this.show_toast("info", "No Changes", "There are no assignment changes to save.", 2000);
        this.close_assign_modal();
    },
    handle_assignment_save_success(changes) {
        this.show_toast("success", "Assignments Saved", "The selected form assignments have been updated successfully.", 2000);
        this.handle_assignment_success(changes.selectedProfileIds, changes.selectedPortalIds);
    },
    handle_assignment_save_error() {
        this.show_toast("error", "Assignment Failed", "An error occurred while saving the form assignments. Please try again.");
    },
    async save_assignment_changes(changes) {
        if (changes.hasUnassignments) {
            await this.post_json_request(
                `${process.env.VUE_APP_BACKEND_API_URL}/system_management/unassign_profile_question/`,
                getAssignmentPayload(
                    this.form_id,
                    changes.removedProfileIds,
                    changes.removedPortalIds,
                    this.selected_business_tab
                )
            );
        }

        if (changes.hasAssignments) {
            await this.post_json_request(
                `${process.env.VUE_APP_BACKEND_API_URL}/system_management/assign_profile_question/`,
                getAssignmentPayload(
                    this.form_id,
                    changes.addedProfileIds,
                    changes.addedPortalIds,
                    this.selected_business_tab
                )
            );
        }
    },
    async assignQuestions() {
        if (!this.has_assignment_selection()) {
            this.notify_no_assignment_selection();
            return;
        }

        const changes = buildAssignmentChangeSet(this);

        if (!this.has_assignment_changes(changes)) {
            this.notify_no_assignment_changes();
            return;
        }

        try {
            await this.save_assignment_changes(changes);
            this.handle_assignment_save_success(changes);
        } catch {
            this.handle_assignment_save_error();
        }
    },
    prepareAssignQuestions(form) {
        this.form_id = form.id;
        this.reset_assignment_selections();
        this.form_error_message = "";

        if (!hasAssignableQuestions(form)) {
            this.form_error_message = "You cannot assign this form without sections and questions.";
            return;
        }

        this.selected_profiles = mapAssignedProfileIds(this.profile_types, form.assigned_profile_types);
        this.initial_selected_profiles = [...this.selected_profiles];
        this.selected_portals = mapAssignedPortalIds(form.assigned_portals);
        this.initial_selected_portals = [...this.selected_portals];
    },
};
